import { useEffect, useRef, useState } from 'react'
import { EventService } from '../../../services/EventService'
import { DriftHud } from '../../hud/drift/DriftHud'
import { KingOfTheDrift } from '../kod/KingOfTheDrift'
import { DriftEventAnnounce } from '../preparation/announce/DriftEventAnnounce'
import { EventAnnounce } from '../preparation/announce/DriftEventAnnounce.types'
import { EventCountdown } from './countdown/EventCountdown'
import { ParticipantList } from './participants/ParticipantList'


interface EventData {
	remainingUntilEnd: number,
	players: {
		name: string,
		self: boolean,
		points: number
	}[]
}

export type EventType = 'KING OF THE DRIFT' | 'DRIFT ATTACK' | 'NIGHT SESSION' | 'DRIFT SPRINT' | 'DRIFT COMBO CHALLENGE'

export const EventHud = () => {

	const [eventData, setEventData] = useState<EventData | null>(null)
	const [driftEventAnnounce, setDriftEventAnnounce] = useState<EventAnnounce | null>(null)
	const [eventType, setEventType] = useState<EventType | null>(null)

	const announceTimeoutRef = useRef<number | null>(null)
	const announceIdRef = useRef(0)
	const eventSourceRef = useRef<EventSource | null>(null)

	useEffect(() => {
		const token = localStorage.getItem("accessToken") || ""
		const es = EventService.getInviteSSE(token)

		eventSourceRef.current = es

		const announceHandler = (e: Event) => {
			const messageEvent = e as MessageEvent
			const data = JSON.parse(messageEvent.data) as Omit<EventAnnounce, 'id'>

			announceIdRef.current += 1

			const getNextEventAnnounce = (): EventAnnounce => {
				if (data.event && data.event.eventName) {
					setEventType(data.event.eventName as EventType)
					return {
						id: announceIdRef.current,
						event: {
							eventName: data.event.eventName,
							instruction: data.event.instruction
						}
					}
				} else if (data.other && data.other.title) {
					return {
						id: announceIdRef.current,
						other: {
							title: data.other.title,
							text: data.other.text
						}
					}
				}

				return {
					id: announceIdRef.current,
					other: {
						title: "",
						text: ""
					}
				}
			}

			const nextEventAnnounce = getNextEventAnnounce()
			setDriftEventAnnounce(nextEventAnnounce)

			if (announceTimeoutRef.current) {
				window.clearTimeout(announceTimeoutRef.current)
			}

			const DRIFT_ANNOUNCE_LIFETIME_MS = 4400
			announceTimeoutRef.current = window.setTimeout(() => {
				setDriftEventAnnounce(current =>
					current?.id === nextEventAnnounce.id ? null : current
				)
			}, DRIFT_ANNOUNCE_LIFETIME_MS)
		}

		es?.addEventListener("INIT", (e: Event) => {
			const messageEvent = e as MessageEvent
			console.log("SSE connected:", messageEvent.data)
		})

		es?.addEventListener("EVENT_UPDATE_STATE", (e: Event) => {
			const messageEvent = e as MessageEvent
			const eventData = JSON.parse(messageEvent.data) as EventData
			setEventData(eventData)
		})

		es?.addEventListener('EVENT_ANNOUNCE', announceHandler)

		return () => {
			eventSourceRef.current?.close()
			eventSourceRef.current = null
		}
	}, [])

	return (
		<div>
			{driftEventAnnounce && (
				<DriftEventAnnounce
					key={driftEventAnnounce.id}
					data={driftEventAnnounce}
				/>
			)}

			<ParticipantList participants={eventData?.players || []} />

			<EventCountdown remaining={eventData?.remainingUntilEnd || 0} />

			{eventType && eventType === "KING OF THE DRIFT" && eventSourceRef.current && (
				<KingOfTheDrift eventSource={eventSourceRef.current} />
			)}

			<DriftHud />
		</div>
	)
}